import { UserModel } from '../shared/types';
import { baseApi } from './base';

const functionUrl = `${process.env.REACT_APP_FUNCTION_HOST_URL}/api/v1/users`;

export const userAdminApi = {
    getUsers: async (userIds?: string): Promise<UserModel[]> => {
        let queryParams = '';
        if (userIds) queryParams = `userIds=${userIds}`;
        return baseApi.get(`${functionUrl}?${queryParams}`);
    },
    getUsersByEmail: async (email: string): Promise<UserModel[]> => {
        const queryParams = `email=${email}`;
        return baseApi.get(`${functionUrl}?${queryParams}`);
    },
    assignRole: async (body: UserModel): Promise<any> => {
        return baseApi.put(`${functionUrl}/${body.id}`, body);
    },
};
